import {KeyboardArrowDown, KeyboardArrowUp} from "@mui/icons-material";
import {Box, styled, Typography} from "@mui/material";
import {COLORS} from "../../ui/Theme";
import {useState} from "react";

const ListItem = styled("div")({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: "4px",
});
const ListItemButton = styled("div")({
    cursor: "pointer",
    background: "white",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: "13px",
    padding: "10px 12px",
    color: "#9e9e9e",
});
const Collapse = styled("div")({
    backgroundColor: "white",
    display: "flex",
    gap: "10px",
    flexDirection: "column",
    borderRadius: "13px",
    padding: "10px 12px",
});

export const AccordionContainer = ({children, icon, title}) => {
    const [currentList, setCurrentList] = useState("");

    const handleOpenList = (title) => {
        if (title === currentList) setCurrentList("");
        else setCurrentList(title);
    };

    return (
        <ListItem
            sx={{
                width: "100%",
            }}
        >
            <ListItemButton onClick={() => handleOpenList(title)}>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 1,
                    }}
                >
                    {icon}
                    <Typography sx={{fontSize: "14px", color: "initial"}}>
                        {title}
                    </Typography>
                </Box>
                {title === currentList ? (
                    <KeyboardArrowUp
                        sx={{width: "24px", bgcolor: COLORS.SOFTGRAY, borderRadius: 1}}
                    />
                ) : (
                    <KeyboardArrowDown sx={{width: "24px"}}/>
                )}
            </ListItemButton>
            {title === currentList && <Collapse>{children}</Collapse>}
        </ListItem>
    );
};
